import { IconButton } from '@creditornot/cb-button';
import { Trashbin } from '@creditornot/cb-icons';
import React from 'react';
import styled from 'styled-components';

import DraggableImage from './DraggableImage';
import { useObjectUrl } from '../utils';

type Props = {
  className?: string;
  image: {
    id: string;
    type: 'new-image';
    file: File;
  };
  interactionsDisabled: boolean;
  onRemove: (imageId: string) => void;
};

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const NewImage = ({ image, interactionsDisabled, onRemove }: Props) => {
  const objectUrl = useObjectUrl(image.file);

  if (!objectUrl) {
    return null;
  }

  return (
    <DraggableImage
      draggingDisabled={interactionsDisabled}
      imageId={image.id}
      imageUrl={objectUrl}
      rightContent={
        <Actions>
          <IconButton disabled={interactionsDisabled} size="tiny" onClick={() => onRemove(image.id)} variant="red">
            <Trashbin />
          </IconButton>
        </Actions>
      }
    />
  );
};

export default React.memo(NewImage);
